import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const DashboardCard = ({ 
  title, 
  subtitle,
  children, 
  headerControls,
  className = '',
  icon: Icon
}) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      className={`
        relative 
        overflow-hidden 
        rounded-lg 
        transition-all 
        duration-200 
        ${
          isDarkMode
            ? "border border-gray-800 bg-[linear-gradient(to_top_right,_#027d5d,_#0f766e,_#115e59,_#0f172a,_#0b0f1a)] shadow-md dark:shadow-none hover:shadow-lg"
            : "border border-gray-200 dark:border-gray-700 bg-gradient-to-b from-blue-50 to-white shadow-sm hover:shadow-md dark:shadow-none"
        }
        ${className}
      `}
    >
      {/* Header */}
      <div className="flex items-center justify-between px-4 py-2">
        <div className="flex items-center space-x-2 whitespace-nowrap">
          {Icon && (
            <Icon 
              className={`
                w-5 h-5 flex-shrink-0
                ${isDarkMode ? "text-teal-300" : "text-teal-600"}
              `}
            />
          )}
          <div>
            <h3 className={`
              text-sm font-semibold whitespace-nowrap
              ${isDarkMode ? "text-white" : "text-gray-900"}
            `}>
              {title}
            </h3>
            {subtitle && (
              <p className="text-xs text-gray-500 dark:text-gray-400">
                {subtitle}
              </p>
            )}
          </div>
        </div>
        <div className="flex items-center whitespace-nowrap">
          {headerControls}
        </div>
      </div>

      {/* Content */}
      {children}
    </div>
  );
};

export default DashboardCard; 